/**
 * Registra o service worker para habilitar PWA.
 * Chamado uma vez no index.js após o app montar.
 */
export function registerServiceWorker() {
  if ('serviceWorker' in navigator) {
    window.addEventListener('load', () => {
      navigator.serviceWorker
        .register('/service-worker.js')
        .then((reg) => {
          console.log('[SW] Registrado:', reg.scope);

          // Detecta atualização disponível e avisa o usuário
          reg.addEventListener('updatefound', () => {
            const newWorker = reg.installing;
            if (!newWorker) return;
            newWorker.addEventListener('statechange', () => {
              if (
                newWorker.state === 'installed' &&
                navigator.serviceWorker.controller
              ) {
                if (
                  window.confirm(
                    'Nova versão disponível! Deseja atualizar agora?'
                  )
                ) {
                  newWorker.postMessage({ type: 'SKIP_WAITING' });
                  window.location.reload();
                }
              }
            });
          });
        })
        .catch((err) => console.warn('[SW] Falha no registro:', err));
    });
  }
}
